module.exports = __webpack_public_path__ + "c25f12c17b018b688eb98b4f779558d7.svg";